export const PASSWORD_STRENGTH_LABELS = ["", "Weak", "Fair", "Good", "Strong", "Very Strong"];
export const PASSWORD_STRENGTH_COLORS = ["", "#ff0000", "#fa8c16", "#FABB02", "#52c41a", "#237804"];

export const PASSWORD_STRENGTH_CRITERIA = [
  { label: "8+ chars", minScore: 1 },
  { label: "Uppercase", minScore: 3 },
  { label: "Number", minScore: 4 },
  { label: "Symbol", minScore: 5 },
];

export const SECURITY_QUESTIONS_QUERY_KEY = ["profile", "security-questions"];
export const USER_SECURITY_QUESTION_QUERY_KEY = (userId) => ["profile", "security-question", userId];

export const PROFILE_TABS = {
  PROFILE: "profile",
  PASSWORD: "password",
} ;
